module.exports = __webpack_public_path__ + "img/logo.72517ee9.svg";